define('views/modules/calendar/nutrition/nutrient/form/nutrient-form-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    // 'models/calendar/nutrition/food',
    // views
    // 'views/parts/form/textbox',
    // templates
    'text!templates/modules/calendar/nutrition/nutrient/form/nutrient-form-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    // MFood,
    // views
    // VTextbox,
    // templates
    TNutrientFormItem
) {

    var VNutrientFormItem = Backbone.Epoxy.View.extend({
        template: TNutrientFormItem,
        className: 'nutrient-form-item form-group row',
        regions: {
            value: '.nutrient-value',
            unit: '.nutrient-unit'
        },
        initialize: function(options) {
            options = options || {};
            var model = this.model;
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));
            this.applyBindings();
            return this;
        },

    });

    return VNutrientFormItem;

});

